import { forwardRef } from 'react';
import cn from 'classnames';
import { Tooltip, type ITooltip, type TooltipRefProps } from 'react-tooltip';
import { useTheme } from '../../theme/ThemeProvider';
import styles from './styles.module.scss';

export const AppTooltip = forwardRef<TooltipRefProps, ITooltip>(
    ({ className, variant, opacity = 1, place = 'bottom', ...rest }, ref) => {
        const { theme } = useTheme();

        return (
            <Tooltip
                ref={ref}
                place={place}
                variant={variant ?? theme}
                opacity={opacity}
                className={cn(styles.tooltip, className)}
                {...rest}
            />
        );
    }
);

AppTooltip.displayName = 'AppTooltip';

export type { ITooltip as AppTooltipProps, TooltipRefProps } from 'react-tooltip';
